import { call } from 'typed-redux-saga';

import { parentFrameCommunicator } from '../../../shared/features/parent-frame-communicator';
import { ChannelHolder } from '../../../shared/helpers/channelHolder';
import { IncomingPostMessage } from './types';

export function* watchMessages(callback: (message: IncomingPostMessage) => void) {
    const channelHolder = new ChannelHolder();

    try {
        yield* call(function* () {
            yield* channelHolder.takeEvery(parentFrameCommunicator.onMessage, callback);
        });
    } finally {
        channelHolder.close();
    }
}
